var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{class:_vm.$style.helpCentreItem,attrs:{"href":_vm.url},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("image"),_vm._v(" "),_c('div',{staticClass:"h-full"},[_vm._t("title"),_vm._v(" "),_vm._t("description")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }